import {
  instance as axios,
  setJwtToken,
} from '../../config/axiosInstance'

// ---------------------fetch uploaded playstore screenshots--------------------------
export const fetchPlaystoreScreenshotsApi = async () => {
  const endPoint = `/admin/playstore-screenshot/uploaded-playstore-screenshot`
  return await axios.get(endPoint, setJwtToken())
}

// ---------------------grant playstore screenshot---------------------------
export const grantPlaystoreScreenshotApi = async (data) => {
  const endPoint = `/admin/playstore-screenshot/grant-playstore-screenshot`
  return await axios.put(endPoint, data, setJwtToken())
}

